import { Button, Space, Tooltip } from 'antd';
import { ZoomInOutlined, ZoomOutOutlined } from '@ant-design/icons';

// Stage 5N-9A — small icon-only zoom-in / zoom-out buttons with a
// click-to-reset percentage label between them. Designed to sit next
// to the existing PageHeader actions on the invoice report viewer.
//
// Default = 100%, range = MIN..MAX in STEP increments. Steps are kept
// at one decimal place (round to avoid 0.300000004 drift from repeated
// 0.1 additions in JS float math).
const MIN = 0.5;
const MAX = 2.0;
const STEP = 0.1;
const DEFAULT = 1.0;

const round1 = (n) => Math.round(n * 10) / 10;

export default function ZoomControls({ zoom, onChange, disabled = false }) {
  const value = typeof zoom === 'number' ? zoom : DEFAULT;
  const pct = Math.round(value * 100);

  const zoomOut = () => onChange(Math.max(MIN, round1(value - STEP)));
  const zoomIn = () => onChange(Math.min(MAX, round1(value + STEP)));
  const reset = () => onChange(DEFAULT);

  return (
    <Space size={4}>
      <Tooltip title="Zoom out">
        <Button
          size="small"
          icon={<ZoomOutOutlined />}
          onClick={zoomOut}
          disabled={disabled || value <= MIN}
          aria-label="Zoom out"
        />
      </Tooltip>
      <Tooltip title="Reset zoom (100%)">
        <Button
          size="small"
          onClick={reset}
          disabled={disabled}
          style={{ minWidth: 56, fontVariantNumeric: 'tabular-nums' }}
        >
          {pct}%
        </Button>
      </Tooltip>
      <Tooltip title="Zoom in">
        <Button
          size="small"
          icon={<ZoomInOutlined />}
          onClick={zoomIn}
          disabled={disabled || value >= MAX}
          aria-label="Zoom in"
        />
      </Tooltip>
    </Space>
  );
}

export { MIN, MAX, STEP, DEFAULT };
